/*eslint-disable */
export default {
  name: 'interview-list-screen',
  components: {},
  props: [],
  data () {
    return {
      inviewerData:null,
      inviewerListResults:[]
    }
  },
  computed: {

  },
  mounted () {
    this.$store.dispatch('inViewerListAction').then((res) => {
      console.log(res.data)
    })
  },
  methods: {

  }
}


